import SuccessResponse from '../responses/SuccessResponse';
import Response from '../base/Response';

export default class CardResult {
	/**
	 * Card status
	 */
	public status?: string = undefined;

	/**
	 * Card number masked
	 */
	public mask?: string = undefined;

	/**
	 * Card network brand
	 */
	public network?: string = undefined;

	/**
	 * Card type (debit/credit)
	 */
	public type?: string = undefined;

	/**
	 * Car bin number
	 */
	public bin?: string = undefined;

	/**
	 * Card last 4 numbers
	 */
	public last?: string = undefined;

	/**
	 * Card unique hash number
	 */
	public hash?: string = undefined;

	/**
	 * Billing address
	 */
	public address?: string = undefined;

	/**
	 * Billing country
	 */
	public country?: string = undefined;

	/**
	 * Billing state
	 */
	public state?: string = undefined;

	/**
	 * Billing city
	 */
	public city?: string = undefined;

	/**
	 * Billing postal code
	 */
	public zip?: string = undefined;

	/**
	 * Billing customer email
	 */
	public email?: string = undefined;

	/**
	 * Billing phone
	 */
	public phone?: string = undefined;

	/**
	 * Validate if response type is valid for parse
	 *
	 * @param response
	 * @return
	 */
	static validateResponse(response: Response): boolean {
		return response instanceof SuccessResponse;
	}

	/**
	 * Convert success response to card entity
	 *
	 * @param response
	 * @return
	 */
	static fromResponse(response: SuccessResponse): CardResult {
		const entity = new CardResult();

		Object.getOwnPropertyNames(response.data).map(prop => {
			if (prop in entity) {
				const key = prop as keyof CardResult;

				entity[key] = response.data[prop];
			}
		})

		return entity;
	}
}
